import { render, staticRenderFns } from "./ClassWisePassFailReport.vue?vue&type=template&id=ece35c36&scoped=true&"
import script from "./ClassWisePassFailReport.vue?vue&type=script&lang=js&"
export * from "./ClassWisePassFailReport.vue?vue&type=script&lang=js&"
import style0 from "./ClassWisePassFailReport.vue?vue&type=style&index=0&id=ece35c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece35c36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAutocomplete,VBtn,VCol,VIcon,VRow,VSimpleTable,VSnackbar})
